import{useRef as n,useEffect as t}from"react";function e(e,r){var o=n(r);t((function(){o.current=r}),[r]),t((function(){function n(n){o.current(n)}return document.addEventListener(e,n),function(){document.removeEventListener(e,n)}}),[])}export{e as useDocumentEvent};
//# sourceMappingURL=use-document-event.js.map
